export enum THEMES {
  DEFAULT = 'DEFAULT',
  DARK = 'DARK',
  LIGHT = 'LIGHT',
  BLUE = 'BLUE',
  GREEN = 'GREEN',
  INDIGO = 'INDIGO',
};
